import { FontFamily } from './fontFamily';
import { FontWeight } from './fontWeight';
import { typographyScale, TypographyVariant } from './scale';
import widths from './widths';

export const getMuiTypography = (breakpoints) => ({
  fontFamily: FontFamily.regular,
  fontFamilyBold: FontFamily.bold,
  fontFamilyExtraBold: FontFamily.extraBold,

  h1: {
    ...typographyScale[TypographyVariant.HeadlineLarge],
    fontWeight: FontWeight.bold,
  },
  h2: {
    ...typographyScale[TypographyVariant.HeadlineMedium],
    fontWeight: FontWeight.bold,
  },
  h3: {
    ...typographyScale[TypographyVariant.HeadlineSmall],
    fontWeight: FontWeight.medium,
  },
  h4: {
    ...typographyScale[TypographyVariant.TitleLarge],
    fontWeight: FontWeight.medium,
  },
  h5: {
    ...typographyScale[TypographyVariant.TitleMedium],
    fontWeight: FontWeight.medium,
  },
  h6: {
    ...typographyScale[TypographyVariant.TitleSmall],
    fontWeight: FontWeight.medium,
  },
  subtitle1: {
    ...typographyScale[TypographyVariant.TitleMedium],
  },
  subtitle2: {
    ...typographyScale[TypographyVariant.TitleSmall],
  },
  body1: {
    ...typographyScale[TypographyVariant.BodyLarge],
  },
  body2: {
    ...typographyScale[TypographyVariant.BodyMedium],
  },
  button: {
    ...typographyScale[TypographyVariant.LabelLarge],
    textTransform: 'none',
  },
  caption: {
    ...typographyScale[TypographyVariant.BodySmall],
  },
  overline: {
    ...typographyScale[TypographyVariant.LabelSmall],
    textTransform: 'uppercase',
  },

  richText: {
    fontSize: '22px',
    fontWeight: FontWeight.regular,
    lineHeight: 1.5,
    textAlign: 'left',
    display: 'block',
    [breakpoints.up('sm')]: {
      fontSize: '24px',
    },
    [breakpoints.up('md')]: {
      fontSize: '32px',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: FontWeight.bold,
    lineHeight: 1.08,
    textAlign: 'left',
    display: 'block',
  },
  subtitle: {
    fontSize: '16px',
    fontWeight: FontWeight.regular,
    lineHeight: 1.08,
    textAlign: 'left',
    display: 'block',
    [breakpoints.up('sm')]: {
      fontSize: '18px',
    },
  },
  inputLabel: {
    fontSize: '14px',
    [breakpoints.up('sm')]: {
      fontSize: '18px',
    },
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: FontWeight.bold,
    [breakpoints.up('sm')]: {
      fontSize: '36px',
    },
  },
});

export const textVariants = {
  screenTitle: {
    variant: 'h3',
  },
  sectionTitle: {
    variant: 'h5',
  },
  body: {
    variant: 'body2',
  },
  bodyStrong: {
    variant: 'body1',
  },
  helper: {
    variant: 'caption',
  },
  actionLink: {
    variant: 'button',
  },
  chipLabel: {
    variant: 'overline',
  },
};

export { FontFamily, FontWeight, typographyScale, TypographyVariant, widths };

